import React, { useEffect } from 'react'
import { StatsigProvider, useClientAsyncInit } from '@statsig/react-bindings'

import { useFeatureStoreData } from './FeatureStoreDataProvider'
import StatsigFeatureBadge from './StatsigFeatureBadge'

import { StatsigFeatureGateNames } from './constants'

import { PageLoader } from '../../Web/PageLoader'

import domainToContract from './utils/domain-to-contract'
import { environment } from './utils/get-environment'

/**
 * Initializes Statsig client with feature store data
 * @type {React.FC<{initData: any}>}
 */
const StatsigClientProvider = ({ initData, children }) => {
  const { client, isLoading: clientLoading } = useClientAsyncInit(
    process.env.REACT_APP_WEB_STATSIG_CLIENT_API_KEY,
    domainToContract(initData),
    {
      environment: environment(),
      disableStorage: true,
    }
  )

  useEffect(() => {
    if (client && initData) {
      client.updateUserAsync(domainToContract(initData))
    }
  }, [client, initData])

  if (clientLoading || !client) {
    return <PageLoader />
  }

  return (
    <StatsigProvider client={client} loadingComponent={<PageLoader />}>
      <StatsigFeatureBadge gateName={StatsigFeatureGateNames.WEB_HELLO_WORLD} position="bottom-left" />
      {children}
    </StatsigProvider>
  )
}

/**
 * Main Statsig provider that fetches data and initializes the client
 * @type {React.FC}
 */
const WebStatsigProvider = ({ children }) => {
  const { data: initData, isLoading: dataLoading } = useFeatureStoreData()

  if (dataLoading) {
    return <PageLoader />
  }

  if (!initData) {
    console.warn('[Statsig] No init data available, skipping initialization')
    return children
  }

  const key=`${initData.user_id}-${initData.parent_account_id}`

  return <StatsigClientProvider key={key} initData={initData}>{children}</StatsigClientProvider>
}

export default WebStatsigProvider
